var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Modal, Spin } from 'antd';
import styled from 'styled-components';
import HTMLReactParser from 'html-react-parser';
import { LoadingOutlined } from '@ant-design/icons';
import { IsMobile } from '../../../Utils/UtilityFunctions';
import classNames from 'classnames';
import Empty from '../assets/svgIcons/Empty';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n"], ["\n"])));
var defaultProps = {
    children: _jsx("div", {}),
    title: '',
    width: '530px',
    description: '',
    email: '',
    onClickNext: function () { },
    onClickCancel: function () { },
    nextText: '',
    cancelText: '',
    closePopup: false,
    nextLoading: false,
    borderedButtons: false,
    isChatbotPopup: false,
    wrapperClass: '',
};
var ModalWidget = function ModalWidget(props) {
    var title = props.title, description = props.description, width = props.width, isChatbotPopup = props.isChatbotPopup, nextText = props.nextText, cancelText = props.cancelText, closePopup = props.closePopup, onClickCancel = props.onClickCancel, wrapperClass = props.wrapperClass, onClickNext = props.onClickNext, children = props.children, nextLoading = props.nextLoading, borderedButtons = props.borderedButtons, email = props.email;
    var _a = useState(true), isModalVisible = _a[0], setIsModalVisible = _a[1];
    var isMobile = IsMobile();
    var isShowModal = function () {
        setIsModalVisible(!isModalVisible);
    };
    return (_jsxs(Wrapper, { children: [_jsx("span", { onClick: isShowModal, onKeyPress: isShowModal, role: "button", tabIndex: 0 }), _jsxs(Modal, __assign({ visible: isModalVisible, centered: true, closeIcon: _jsx(Empty, {}), width: isMobile ? '370px' : width, getContainer: isChatbotPopup ? function () { return document.querySelector('.container-inner-area') || document.body; } : '', wrapClassName: classNames("modal-c-widget ".concat(wrapperClass), { gilroyV3Popup: isChatbotPopup }) }, { children: [_jsx("h6", __assign({ className: "title" }, { children: title })), _jsx("p", __assign({ className: "description" }, { children: description && HTMLReactParser(description) })), email ? (_jsx("a", __assign({ className: "mail_link", href: "mailto:".concat(email), target: "_blank", rel: "noopener noreferrer", style: { fontSize: '20px' } }, { children: email }))) : null, children, _jsxs("div", __assign({ className: "ant-modal-footer custom-footer" }, { children: [nextText
                                && (_jsxs("button", __assign({ className: "ant-btn ".concat(borderedButtons ? 'borderedButton' : '', " ant-btn-primary"), type: "button", "aria-label": nextText, onClick: onClickNext, disabled: nextLoading }, { children: [nextLoading
                                            ? (_jsx(Spin, { indicator: (_jsx(LoadingOutlined, { style: {
                                                        fontSize: 18,
                                                        color: '#fff',
                                                    }, spin: true })) })) : null, nextText] }))), cancelText
                                && (_jsx("button", __assign({ className: "ant-btn ".concat(borderedButtons ? 'borderedButton' : '', " ant-btn-default"), type: "button", "aria-label": cancelText, onClick: onClickCancel }, { children: cancelText }))), closePopup
                                && (_jsx("button", __assign({ className: "ant-btn ".concat(borderedButtons ? 'borderedButton' : '', " ant-btn-default"), type: "button", "aria-label": "Close", onClick: isShowModal }, { children: "Close" })))] }))] }))] }));
};
ModalWidget.defaultProps = defaultProps;
export default ModalWidget;
var templateObject_1;
